import PaymentInfoModal from "./paymentInfoModal/paymentInfoModal.vue";
import CardApi from "@/services/api/cardApi";

const CardApiService = new CardApi();

export default {
  components: {
    PaymentInfoModal,
  },

  data() {
    return {
      loading: false,
      cards: [],
      cardForEdit: null,
      showCreateEditCardModal: false,
    };
  },

  methods: {
    getCards,
    confirmRemove,
    remove,
    showEditCardModal,
    closeEditCardModal,
    submit,
  },

  mounted() {
    this.getCards();
  },
};

async function getCards() {
  this.loading = true;

  try {
    const { data } = await CardApiService.getStoredCreditCardList();

    this.cards = data;
  } catch (error) {
    this.$swal("Attention", error.response.data.error_message);
  } finally {
    this.loading = false;
  }
}

function confirmRemove(card) {
  this.$swal({
    title: "Are you sure?",
    text: "Are you sure you want to remove this card information?",
    showCancelButton: true,
    cancelButtonText: "Cancel",
    confirmButtonText: "Confirm",
  }).then((confirm) => {
    if (confirm.value) {
      this.$loader.$emit("trigger", true);
      this.remove(card.card_id);
    }
  });
}

async function remove(id) {
  try {
    await CardApiService.removeCardById(id);
    this.$swal("Success", "Payment info successfully removed");
    this.getCards();
  } catch (error) {
    this.$swal("Attention", error.response.data.error_message);
  } finally {
    this.$loader.$emit("trigger", false);
  }
}

function showEditCardModal(card) {
  this.cardForEdit = card;
  this.showCreateEditCardModal = true;
}

function closeEditCardModal() {
  this.cardForEdit = null;
  this.showCreateEditCardModal = false;
}

async function submit(data) {
  try {
    const request = {
      stripe_card_token: data.token,
      first_name: data.firstName,
      last_name: data.lastName,
    };

    await CardApiService.updateCard(request);
    this.cardForEdit = null;
    this.$swal("Success", "Card updated successfully");
    this.closeEditCardModal();
    this.getCards();
  } catch (error) {
    this.$refs.paymentInfoModal.request_started = false;
    this.$swal("Attention", error.response.data.error_message);
  }
}
